import Card from '../../components/Card';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useT } from '../../utils/useTranslation';
import Pagination from '../../components/Pagination';
import api, { DB_TYPE } from '../../api';
import { db } from '../../firebase';
import { getDocs, collection, query, where, orderBy } from 'firebase/firestore';
import heroBg from '../../assets/sas_hero_new.png';
import ajrakTexture from '../../assets/ajrak_texture_new.jpg';
import { motion } from 'framer-motion';
import HeroBackground from '../../components/ui/HeroBackground';
import { useAuth } from '../../context/AuthContext';
const ITEMS_PER_PAGE = 9;
export default function EventsPage() {
  const { user } = useAuth();
  const t = useT();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [type, setType] = useState('');
  const [page, setPage] = useState(1);
  const [branches, setBranches] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    setPage(1);
    const fetchItems = async () => {
      if (DB_TYPE === 'firebase') {
        try {
          let q = collection(db, 'events');
          const constraints = [orderBy('createdAt', 'desc')];
          if (type) constraints.push(where('type', '==', type));
          
          const finalQuery = query(q, ...constraints);
          const snap = await getDocs(finalQuery);
          let allEvents = snap.docs.map(d => ({ _id: d.id, ...d.data() }));
          
          allEvents = allEvents.filter(e => e.isGlobal === true || (user && (user.role === 'main_admin' || user.branchId === e.branch || (user.role === 'branch_admin' && (!user.branchId || e.branch === '')))));
          
          setItems(allEvents);
          
          const bSnap = await getDocs(collection(db, 'branches'));
          setBranches(bSnap.docs.map(d => ({ _id: d.id, ...d.data() })));
          
          setLoading(false);
        } catch (err) {
          console.error(err);
          setLoading(false);
        }
      } else {
        const qStr = type ? `?type=${type}` : '';
        api.get(`/events${qStr}`).then(r => {
          setItems(r.data);
          setLoading(false);
        }).catch(() => setLoading(false));
      }
    };
    fetchItems();
  }, [type]);
  const typeColor = t => ({
    event: 'navy',
    news: 'green',
    announcement: 'red'
  })[t] || 'navy';
  const typeIcon = t => ({
    event: '📅',
    news: '📰',
    announcement: '📢'
  })[t] || '📄';
  const isRTL = t.language === 'sindhi';

  return <>
    {/* Hero Section */}
    <div className="hero-premium" style={{
      minHeight: '400px',
      padding: '120px 2rem 100px',
      direction: isRTL ? 'rtl' : 'ltr'
    }}>
      <HeroBackground />

        <div style={{
          position: 'relative',
          zIndex: 10
        }}>
          <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-gradient-gold" style={{
            fontSize: 56,
            fontWeight: 800,
            marginBottom: 16,
            letterSpacing: -1,
            fontFamily: isRTL ? 'var(--font-sindhi)' : 'var(--font-display)'
          }}>
            {t('eventsNews')}
          </motion.h1>
          <p style={{
            color: 'rgba(255,255,255,0.7)',
            fontSize: 18,
            maxWidth: 600,
            margin: isRTL ? '0 0 0 auto' : '0 auto 0 0',
            fontWeight: 500,
            lineHeight: 1.6,
            textAlign: isRTL ? 'right' : 'left'
          }}>
            {t('eventsSubtitle') || 'Stay connected with the latest literary festivals, workshops, and organizational updates from across the Sindhi literary world.'}
          </p>
        </div>
      </div>

    <div style={{
      background: 'var(--sindhi-ivory)',
      backgroundImage: `url(${ajrakTexture})`,
      backgroundSize: '600px 600px',
      backgroundRepeat: 'repeat',
      position: 'relative',
      zIndex: 10,
      marginTop: '-40px'
    }}>
      <div style={{
        position: 'absolute',
        inset: 0,
        backdropFilter: 'blur(3px)',
        WebkitBackdropFilter: 'blur(3px)',
        background: 'rgba(253,248,235,0.7)',
        zIndex: 0,
        pointerEvents: 'none'
      }} />
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '0 24px 100px',
        position: 'relative',
        zIndex: 1
      }}>
        {/* Tabs */}
        <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} style={{
          display: 'flex',
          gap: 12,
          marginBottom: 60,
          background: 'rgba(255,255,255,0.8)',
          backdropFilter: 'blur(20px)',
          padding: '12px',
          borderRadius: 24,
          border: '1px solid rgba(255,255,255,0.5)',
          boxShadow: '0 25px 50px -12px rgba(0,0,0,0.1)',
          overflowX: 'auto',
          whiteSpace: 'nowrap',
          justifyContent: 'center',
          direction: isRTL ? 'rtl' : 'ltr'
        }}>
          {[['', t('all')], ['event', t('eventsTab')], ['news', t('newsTab')], ['announcement', t('announcementsTab')]].map(([v, l]) => <button key={v} style={{
            padding: '12px 28px',
            borderRadius: 16,
            fontSize: 14,
            fontWeight: 800,
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            background: type === v ? 'var(--sindhi-maroon)' : 'transparent',
            color: type === v ? 'white' : 'var(--sindhi-navy)',
            boxShadow: type === v ? '0 10px 20px -5px var(--sindhi-maroon-glow)' : 'none',
            textTransform: 'uppercase',
            letterSpacing: 1,
            fontFamily: isRTL ? 'var(--font-sindhi)' : 'inherit'
          }} onClick={() => {
            setType(v);
            setLoading(true);
          }}>
            {l}
          </button>)}
        </motion.div>

        {loading ? <div className="spinner" /> : items.length === 0 ? <Card style={{
          textAlign: 'center',
          padding: '80px 0',
          color: 'var(--sindhi-text-muted)'
        }}>
          <div style={{
            fontSize: 48,
            marginBottom: 16
          }}>🗓️</div>
          {t('noEvents')}
        </Card> : (() => {
          const totalPages = Math.ceil(items.length / ITEMS_PER_PAGE);
          const paged = items.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);
          return <>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))',
              gap: 32,
              direction: isRTL ? 'rtl' : 'ltr'
            }}>
              {paged.map((item, i) => <motion.div key={item._id} initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} whileHover={{
                y: -12,
                scale: 1.02
              }} transition={{
                delay: i * 0.05,
                type: 'spring',
                stiffness: 300,
                damping: 20
              }} className="card-royal" style={{
                padding: 0,
                overflow: 'hidden',
                cursor: 'pointer',
                background: 'white',
                textAlign: isRTL ? 'right' : 'left'
              }} onClick={() => navigate(`/events/${item._id}`)}>
                {/* Image Area */}
                <div style={{
                  height: 240,
                  background: 'var(--sindhi-navy)',
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative'
                }}>
                  {item.photo ? <motion.img whileHover={{
                    scale: 1.1
                  }} transition={{
                    duration: 0.6
                  }} src={item.photo} alt={isRTL ? (item.titleSindhi || item.title) : item.title} style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }} /> : <span style={{
                    fontSize: 80,
                    opacity: 0.2
                  }}>{typeIcon(item.type)}</span>}

                  {/* Category Badge */}
                  <div style={{
                    position: 'absolute',
                    top: 20,
                    [isRTL ? 'right' : 'left']: 20
                  }}>
                    <span style={{
                      fontSize: 10,
                      fontWeight: 900,
                      textTransform: 'uppercase',
                      background: 'rgba(255,255,255,0.9)',
                      color: `var(--sindhi-${typeColor(item.type)})`,
                      padding: '6px 14px',
                      borderRadius: 100,
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      letterSpacing: 1,
                      fontFamily: isRTL ? 'var(--font-sindhi)' : 'inherit'
                    }}>
                      {item.type === 'event' ? t('event') : item.type === 'news' ? t('news') : t('announcement')}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div style={{
                  padding: 32
                }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 16
                  }}>
                    <div style={{
                      fontSize: 13,
                      color: 'var(--sindhi-maroon)',
                      fontWeight: 800,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 6
                    }}>
                      <span>📅</span> {item.date ? new Date(item.date).toLocaleDateString(isRTL ? 'sd-PK' : 'en-PK', {
                        month: 'long',
                        day: 'numeric',
                        year: 'numeric'
                      }) : 'Ongoing'}
                    </div>
                    {item.isGlobal && <span style={{
                      fontSize: 10,
                      fontWeight: 900,
                      textTransform: 'uppercase',
                      background: 'var(--sindhi-ivory)',
                      color: 'var(--sindhi-gold)',
                      padding: '4px 10px',
                      borderRadius: 6,
                      border: '1px solid var(--sindhi-gold-muted)',
                      fontFamily: isRTL ? 'var(--font-sindhi)' : 'inherit'
                    }}>{t('global')}</span>}
                  </div>

                  <h3 style={{
                    fontSize: isRTL ? 24 : 20,
                    fontWeight: 800,
                    color: 'var(--sindhi-navy)',
                    marginBottom: 12,
                    lineHeight: 1.4,
                    fontFamily: isRTL ? 'var(--font-sindhi)' : 'var(--font-display)'
                  }}>
                    {isRTL ? (item.titleSindhi || item.title) : item.title}
                  </h3>

                  <p style={{
                    fontSize: 15,
                    color: 'var(--sindhi-text-muted)',
                    lineHeight: 1.8,
                    marginBottom: 24,
                    display: '-webkit-box',
                    WebkitLineClamp: '3',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    fontFamily: isRTL ? 'var(--font-sindhi)' : 'inherit'
                  }}>
                    {(isRTL ? (item.descriptionSindhi || item.description) : item.description) || (isRTL ? "سنڌي ٻولي ۽ ادب جي واڌاري لاءِ هن تقريب ۾ شامل ٿيو." : "Join us for this special literary occasion as we celebrate the richness of Sindhi language and literature.")}
                  </p>

                  <div style={{
                    borderTop: '1px solid var(--sindhi-ivory)',
                    paddingTop: 24,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      fontSize: 13,
                      color: 'var(--sindhi-text-muted)',
                      fontWeight: 600
                    }}>
                      <span style={{
                        color: 'var(--sindhi-gold)'
                      }}>📍</span>
                      {(() => {
                        if (!item.branch) return 'SAS Central';
                        const b = branches.find(br => br._id === item.branch);
                        if (!b) return item.branch;
                        return isRTL ? (b.nameSindhi || b.name) : b.name;
                      })()}
                    </div>
                    <span style={{
                      fontWeight: 800,
                      color: 'var(--sindhi-maroon)',
                      fontSize: 13,
                      textTransform: 'uppercase',
                      letterSpacing: 1,
                      fontFamily: isRTL ? 'var(--font-sindhi)' : 'inherit'
                    }}>
                      {isRTL ? 'وڌيڪ تفصيل ←' : 'Details →'}
                    </span>
                  </div>
                </div>
              </motion.div>)}
            </div>
            <Pagination page={page} totalPages={totalPages} onPageChange={p => {
              setPage(p);
              window.scrollTo({
                top: 400,
                behavior: 'smooth'
              });
            }} />
          </>;
        })()}
      </div>
    </div>
  </>;
}